import "./how_it_works.css";
import { WrapperComponent } from "../../../_imports";
import CreditsImg from "../../../../assets/imgs/mockups/credits.png";

function HowItWorks() {
    return (
        <section className="how-section">
            <WrapperComponent>
                <div className="how-wrapper">
                    <div className="how-info-box">
                        <div className="how-content">
                            <h2 className="how-title">Como funciona?</h2>
                            <p className="how-text">
                                Nosso sistema funciona com créditos. <br />Você cadastra sua vaga e escolhe um modelo de divulgação, com ou sem triagem, depois você determina quanto tempo deseja manter a vaga anunciada, conforme a quantidade de dias e o modelo do anuncio, é definido a quantidade de creditos que vai custar.
                            </p>
                            <ul className="how-list">
                                <li>
                                    <strong>Divulgação Simples (1 crédito/dia):</strong>
                                    <p>Divulgamos a vaga nos principais canais de emprego da cidade da vaga, e entregamos todos os curriculos na plataforma.</p>
                                </li>
                                <li>
                                    <strong>Com Triagem (2 créditos/dia):</strong>
                                    <p>Além do anúncio, a Tonia entrevista todos os candidatos para aquela vaga e entrega todos os currículos já analisados pela IA.</p>
                                </li>
                            </ul>
                        </div>
                        <div className="how-visual">
                            <img src={CreditsImg} alt="Ilustração explicativa sobre o sistema de créditos" />
                        </div>
                    </div>
                </div>
            </WrapperComponent>
        </section>
    );
}

export default HowItWorks;
